import { useCallback, useEffect, useState } from 'react';

/**
 * Загрузка с возможностью повторить (T11.3).
 *
 * Общий хук, а не три `useState` в каждом экране: состояний у загрузки
 * ровно три, и повторять их разбор на каждом экране значит однажды
 * забыть одно — обычно отказ, потому что о нём думают последним.
 */

export type Loading<T> =
  | { readonly kind: 'loading' }
  | { readonly kind: 'ready'; readonly value: T }
  | { readonly kind: 'failed'; readonly error: unknown };

export function useLoad<T>(load: () => Promise<T>): [Loading<T>, () => void] {
  const [state, setState] = useState<Loading<T>>({ kind: 'loading' });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let alive = true;

    setState({ kind: 'loading' });

    load()
      .then((value) => {
        // Экран мог смениться, пока шёл запрос: обновлять состояние
        // ушедшего экрана значит показывать чужие данные
        if (alive) setState({ kind: 'ready', value });
      })
      .catch((error: unknown) => {
        if (alive) setState({ kind: 'failed', error });
      });

    return () => {
      alive = false;
    };
  }, [attempt, load]);

  return [state, useCallback(() => setAttempt((one) => one + 1), [])];
}
